import React, { type ReactNode } from 'react';
import AkButton from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';

type Props = {
	isDisabled: boolean;
	isLoading: boolean;
	shouldFitContainer: boolean;
	children: ReactNode;
	onClick: () => void;
};

// Mimics the new `isLoading` prop in @atlaskit/button@7.x. This component can
// be deleted when we upgrade to the latest version of @atlaskit/button.
const LoadingButton = (props: Props) => {
	const { children, isDisabled, isLoading, onClick, shouldFitContainer } = props;
	return (
		<AkButton
			onClick={onClick}
			isDisabled={isDisabled}
			// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
			iconAfter={isLoading ? <Spinner size="small" /> : null}
			shouldFitContainer={shouldFitContainer}
		>
			{!isLoading ? children : null}
		</AkButton>
	);
};

export default LoadingButton;
